/* eslint-disable no-underscore-dangle */
import numeral from 'numeral';

export const chartColours = [
    'rgb(97,147,206)',
    'rgb(32,211,189)',
    'rgb(253,240,97)',
    'rgb(63,89,156)',
    'rgb(250,180,231)',
    'rgb(131,208,245)',
    'rgb(150,109,210)',
];

export const valueAsPercentage = (value, total) => `${(value / total * 100).toFixed(2).replace(/\.?0+$/, '')}%`;

export const customTooltips = ({
    tooltip,
    chart,
    colour,
    value,
    text,
    hide,
}) => {

    // Tooltip Element
    const container = chart._chart.canvas.parentNode;
    let tooltipEl = container.querySelector('.chartjs-tooltip');

    // Create element on first render
    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.classList.add('chartjs-tooltip');
        tooltipEl.classList.add('tooltip');
        container.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    if (hide) {
        tooltipEl.style.opacity = 0;
        return;
    }

    const html = `
        ${text}
        <em>${numeral(value).format('0,0.[000]')}</em>
        <span style="background-color:${colour}"></span>
    `;

    tooltipEl.innerHTML = html;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = `${tooltip.caretX}px`;
    tooltipEl.style.top = `${tooltip.caretY}px`;
};
